import styled from 'styled-components'

export const TopBarNavigationWrapper = styled.div`
  position: fixed;
  z-index: 9999;
  width: 100%;
`
